import React, { useRef, useState } from "react";
import ServerPaginationDataGridWithReactQuery from "../../components/common/CustomDataGrid/ServerPaginationDataGridWithReactQuery";
import CustomButton from "../../components/common/CustomButton/CustomButton";
import { getRMList } from "../../utils/urls";
import CreateCredentialsForRmModal from "./CreateCredentialsForRmModal";

const RelationshipManagers = () => {
  const dataGridRef = useRef(null);
  const [selectedRm, setSelectedRm] = useState(null);

  const columns = [
    { field: "name",           headerName: "RM Name" },
    { field: "company_name",   headerName: "Company Name" },
    { field: "contact_number", headerName: "Mobile Number" },
    { field: "email",          headerName: "Email" },
    {
      field: "actions",
      headerName: "Action",
      renderCell: (params) =>
        params?.email ? (
          <span className="text-xs font-medium text-[#10B981] bg-[#E0F9F2] px-3 py-1 rounded-full">
            Credentials Created
          </span>
        ) : (
          <CustomButton
            type="button"
            label="Create Credentials"
            onClick={() => setSelectedRm(params)}
          />
        ),
    },
  ];

  return (
    <>
      <div className="min-h-screen bg-[#F8FAFC] p-1 flex flex-col">
        {/* Header */}
        <div className="mb-6">
          <h1 className="text-xl font-bold text-[#0F172A]">Relationship Managers</h1>
          <p className="text-sm text-[#64748B] mt-0.5">Manage RM accounts and credentials</p>
        </div>

        {/* Table */}
        <div className="bg-white rounded-2xl shadow-sm border border-gray-100 flex-1 overflow-hidden">
          <ServerPaginationDataGridWithReactQuery
            ref={dataGridRef}
            url={getRMList + "/null"}
            requestParameter={{ is_admin_rm: false }}
            limit={10}
            columns={columns}
            isServerPagination={true}
            dataMapper={(list) => list}
          />
        </div>
      </div>

      {selectedRm && (
        <CreateCredentialsForRmModal
          onClose={(flag) => {
            if (flag) dataGridRef.current?.restartComponent();
            setSelectedRm(null);
          }}
          relationship_manager_id={selectedRm?.rm_id}
        />
      )}
    </>
  );
};

export default RelationshipManagers;
